export const companyOptionId = (listboxId, index) =>
  `${listboxId}-option-${index}`
